/** Sentry `environment` tag — aligned across mobile, admin, and API. */
export type SentryDeployEnvironment = "development" | "preview" | "staging" | "production";

const ALLOWED: ReadonlySet<SentryDeployEnvironment> = new Set(["development", "preview", "staging", "production"]);

export function resolveSentryEnvironment(
  raw: string | undefined,
  fallback: SentryDeployEnvironment = "development",
): SentryDeployEnvironment {
  if (raw && ALLOWED.has(raw as SentryDeployEnvironment)) return raw as SentryDeployEnvironment;
  return fallback;
}

/** Paths that should not create traces or error noise (uptime monitors). */
export function isSentryHealthCheckPath(urlOrPath: string): boolean {
  return urlOrPath.includes("/healthz");
}

/** Settings diagnostics (test message/crash) — never when environment is production or runtime is a store/release build. */
export function canShowSentryDevTools(appEnv: SentryDeployEnvironment, isDevRuntime: boolean): boolean {
  return appEnv !== "production" && isDevRuntime;
}
